import { defineComponent } from 'vue';

/**
 * Single dockview body component: resolves panel id from DockviewPanelApi and
 * delegates rendering to ControlDesigner_v3 (injected). Reading params.params._dockRev
 * ties updates to ControlDesigner_v3.updated() bumping all panels so content stays in sync.
 */
export default defineComponent({
    name: 'ControlDesignerDockSlot',
    props: {
        params: { type: Object, default: () => ({}) },
    },
    inject: {
        controlDesignerDockRender: { default: null },
        controlDesignerInstance: { default: null },
    },
    render() {
        const id = this.params?.api?.id;
        void this.params?.params?._dockRev;
        void this.params?.params?._centerActivePanelId;
        void this.params?.params?._jsonTabActive;
        void this.params?.params?._jsonTabGroupActivePanelId;
        void this.params?.params?._leftActivePanelId;
        void this.params?.params?._codeTabActive;
        void this.params?.params?._propertiesTabActive;

        const render =
            this.controlDesignerDockRender
            ?? (this.controlDesignerInstance
                && typeof this.controlDesignerInstance.renderControlDesignerDockPanel === 'function'
                ? (panelId) => this.controlDesignerInstance.renderControlDesignerDockPanel(panelId)
                : null);
        if (!id || typeof render !== 'function') {
            return null;
        }
        return (
            <div
                class="control-designer-dock-slot-root"
                data-control-designer-dock-slot={id}
                style={{ height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column' }}
            >
                {render(id)}
            </div>
        );
    },
});
